import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';



export class AcademicInstanceSchedule{
  PRNNo: string;
  StudentName: string;
  Gender:string;
  PhyDisability:string;
  ReDegree:string;
  ApplyForImprovement:string;
  CourseName:string;
  CoursePatternName:string;
  BranchName:string;
  CoursePartName:string;
  CollegeName:string;
  RequestID: string;
  RequestDate:string;
  TotalFeeAmount: string;
  Activity: string;
}


export class TransferCertificate{
  TransferCertificateID: number;
  StudentID: number;
  ExamInstanceID: number;
  AcademicInstanceID:number;
  OldCollegeID:number;
  NewCollegeID: number;
  CourseID: number;
  BranchID: number;
  CoursePartID: number;
  ApplicationNO: string;
  ApplicationDate: string;
  ApplicationFees: number;
  PaymentFlag:string;
  DeleteFlag: string;
  CreatedLoginID: number;
  UpdatedLoginID: number;
  TransferCollegeName:string;
  CollegeAddress: string;
}

@Injectable({
  providedIn: 'root'
})
export class TransfercertificateService {

  
  constructor(
    private dataService: DataAccessService) {
  }

  public GetTransferredCollegeChangeData(CourseID,CollegeID) {debugger
    this.dataService.setControllerName = '/PortalCollegeChange/';
    this.dataService.setMethodName = 'GetCollegeForCollegeChange?CourseID='+CourseID+'&CollegeID='+CollegeID; // setting method name from API controller.
    return this.dataService.getAll<TransferCertificate[]>()
  }
  
  public save(data) {debugger
    this.dataService.setControllerName = '/PortalStudentTransferCertificate/';
    this.dataService.setMethodName = 'PostInsertPortalStudentTransferCertificateNEW'; // setting method name from API controller.
    return this.dataService.add<TransferCertificate[]>(data) 
  }

  public GetDataforTransferCertificateList(StudentID,ExamInstanceID,AcademicInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/PortalStudentTransferCertificate/';
    this.dataService.setMethodName = 'GetDataforTransferCertificateList?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&AcademicInstanceID='+AcademicInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
    return this.dataService.getAll<TransferCertificate[]>()
  }
  public GetPortalStudentTransferCertificateListByID(TransferCertificateID) {debugger
    this.dataService.setControllerName = '/PortalStudentTransferCertificate/';
    this.dataService.setMethodName = 'GetPortalStudentTransferCertificateListByID?TransferCertificateID='+ TransferCertificateID+''
    return this.dataService.getAll<TransferCertificate[]>()
  }
public CancelTransferApplication(RequestID,StudentID,AcademicInstanceID,ResultQueryCode) {
  this.dataService.setControllerName = '/PortalStudentTransferCertificate/';
  this.dataService.setMethodName = 'CancelTransferApplication?RequestID='+RequestID+'&StudentID='+StudentID+'&AcademicInstanceID='+AcademicInstanceID+'&ResultQueryCode='+ResultQueryCode+'';
  return this.dataService.getAll<TransferCertificate[]>()
}

public GetUpdatePaymentStatusForTransferCertificate(merchantTxnNo,ExamInstanceID,ApplicationNO,StudentID) {debugger
  this.dataService.setControllerName = '/Payment/';
  this.dataService.setMethodName = 'GetUpdatePaymentStatusForTransferCertificate?merchantTxnNo='+ merchantTxnNo + '&ExamInstanceID='+ExamInstanceID+'&ApplicationNO='+ApplicationNO +'&StudentID='+StudentID; // setting method name from API controller.
  return this.dataService.getAll<TransferCertificate[]>()
}
public CheckTransferCertificateStatusForNewRequest(StudentID,ExamInstanceID,CoursePartID) {debugger
  this.dataService.setControllerName = '/PortalStudentTransferCertificate/';
  this.dataService.setMethodName = 'CheckTransferCertificateStatusForNewRequest?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
  return this.dataService.getAll<TransferCertificate[]>()
}

public GetDocumentPathForTransferCertificate(ApplicationNO,ExamInstanceID) {
  this.dataService.setControllerName = '/PortalStudentTransferCertificate/';
  this.dataService.setMethodName = 'GetDocumentPathForTransferCertificate?ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
  return this.dataService.getAll<TransferCertificate[]>()
}
}
